import "magnific-popup";
import Cookies from "js-cookie";

jQuery( document ).ready(function($) {

  $('.newsletter').on('submit', function (e) {
      e.preventDefault();
      const DATA = $(this).serialize();
  
      $.ajax({
        type: 'POST',
        url: $(this).attr('action'),
        dataType: 'json',
        data: DATA,
        xhrFields: {
          withCredentials: false,
        },
        success: function (data) {    
          $('body').addClass('inner');
          $('.landing').hide();
          $('#warehouse').fadeIn(); 
          $('#trailer').fadeIn(); 
          Cookies.set('registered', true);
          if(window.innerWidth < window.innerHeight){
            $.magnificPopup.open({
              items: {
                src: '#rotate',
                type: 'inline'
              }
            });
          }
        },
        error: function (err) {
          console.log(err);
        }
      });
  });
  
  $('.mfp-inline').magnificPopup({
    closeMarkup: '<button title="%title%" type="button" class="mfp-close">X</button>',
  })

  $('.mfp-audio').magnificPopup({
    closeMarkup: '<button title="%title%" type="button" class="mfp-close">X</button>',
    callbacks: {
      open: function() {
        $('#audio-5')[0].currentTime = 0;
        $('#audio-5')[0].play();
      },
      close: function() {
        $('audio')[0].currentTime = 0;
        $('audio')[0].pause();
      }
    }
  })


  if (Cookies.get('registered')){
    $('body').addClass('inner');
    $('.landing').hide();
    $('#warehouse').fadeIn(); 
    $('#trailer').fadeIn(); 
    if(window.innerWidth < window.innerHeight){
      $.magnificPopup.open({
        items: {
          src: '#rotate',
          type: 'inline'
        }
      });
    }
  }
  
  $('.skip').on('click', function(e){
    e.preventDefault();
    $('body').addClass('inner');
    $('.landing').hide();
    $('#warehouse').fadeIn(); 
    $('#trailer').fadeIn(); 
    if(window.innerWidth < window.innerHeight){
      $.magnificPopup.open({
        items: {
          src: '#rotate',
          type: 'inline'
        }
      });
    }
  })


});